export type DatadogTag = {[k: string]: string | number | DatadogTag};

// More at https://github.com/DataDog/dd-trace-java/blob/master/dd-trace-api/src/main/java/datadog/trace/api/DDSpanTypes.java
type DatadogSpanType = 'web' | 'serverless';

// https://datadoghq.dev/dd-trace-js/modules.html#TraceOptions
type DatadogTraceOptions = { service?: string, resource?: string, type?: DatadogSpanType }

type DatadogTraceFn = (span: DatadogSpan, done: (error?: Error) => void) => any;

export type DatadogSpan = {
  setTag: (key: string, value: string | number | DatadogTag) => void,
  addTags: (tags: DatadogTag) => void
}
export let tracer = new (class {
  /**
   * https://datadoghq.dev/dd-trace-js/interfaces/export_.Tracer.html#trace
   * @param name resource name
   * @param fn 
   */
  trace<T extends DatadogTraceFn>(name: string, fn: T): ReturnType<T>;
  trace<T extends DatadogTraceFn>(name: string, options: DatadogTraceOptions, fn: T): ReturnType<T>;
  trace<T extends DatadogTraceFn>(arg0: string, arg1: T | DatadogTraceOptions, arg2?: T) {
    if (arg2) return arg2({
      setTag: ()=>{},
      addTags: ()=>{},
    }, ()=>{})
    if (typeof arg1 === "function") return arg1({
      setTag: ()=>{},
      addTags: ()=>{},
    }, ()=>{})
  }

  scope() { return ({
    active: (): DatadogSpan | null => null
  })}
  use(plugin: string, config: {
    headers: string[]
  }) {}
})
export function setTypesPackageTracer(_tracer: any) {tracer = _tracer}
